import { GameContext } from '../../../../contexts/GameContext';
import { ZdarKidsGameStepConfiguration } from '../../../../configuration/games/zdar-kids-game/zdarKidsGameContentConfiguration';
import ContinueButton from '../../../common/buttons/ContinueButton';
import React, { useContext, useEffect, useState } from 'react';
import SingleCard from './SingleCard';
import image1 from '../../../../assets/images/games/zdar-kids-game/memory-game/1.webp';
import image2 from '../../../../assets/images/games/zdar-kids-game/memory-game/2.webp';
import image3 from '../../../../assets/images/games/zdar-kids-game/memory-game/3.webp';
import image4 from '../../../../assets/images/games/zdar-kids-game/memory-game/4.webp';
import image5 from '../../../../assets/images/games/zdar-kids-game/memory-game/5.webp';
import image6 from '../../../../assets/images/games/zdar-kids-game/memory-game/6.webp';

export type CardType = {
    src: string;
    id: number;
    matched: boolean;
};

const cardImages: CardType[] = [
    { src: image1, id: 0, matched: false },
    { src: image2, id: 0, matched: false },
    { src: image3, id: 0, matched: false },
    { src: image4, id: 0, matched: false },
    { src: image5, id: 0, matched: false },
    { src: image6, id: 0, matched: false },
];

type Props = {
    onSuccess: () => void;
};
export default function ZdarPexesoCipher({ onSuccess }: Props) {
    const { stepContent } = useContext(GameContext);

    const [cards, setCards] = useState<CardType[]>([]);
    const [choiceOne, setChoiceOne] = useState<CardType | null>(null);
    const [choiceTwo, setChoiceTwo] = useState<CardType | null>(null);
    const [disabled, setDisabled] = useState(false);
    const { continueButtonText } = stepContent as ZdarKidsGameStepConfiguration;
    const [solved, setSolved] = useState(false);

    const shuffleCards = () => {
        const shuffledCards = [...cardImages, ...cardImages]
            .sort(() => Math.random() - 0.5)
            .sort(() => Math.random() - 0.5)
            .sort(() => Math.random() - 0.5)
            .sort(() => Math.random() - 0.5)
            .map((card) => ({ ...card, id: Math.random() }));

        setChoiceOne(null);
        setChoiceTwo(null);
        setCards(shuffledCards);
        setSolved(false);
    };

    const handleChoice = (card: CardType) => {
        choiceOne ? setChoiceTwo(card) : setChoiceOne(card);
    };

    const resetTurn = () => {
        setChoiceOne(null);
        setChoiceTwo(null);
        setDisabled(false);
    };

    useEffect(() => {
        if (choiceOne && choiceTwo) {
            setDisabled(true);
            if (choiceOne.src === choiceTwo.src) {
                setCards((prevCards) =>
                    prevCards.map((card) =>
                        card.src === choiceOne.src
                            ? {
                                  ...card,
                                  matched: true,
                              }
                            : card,
                    ),
                );
            }
            setTimeout(() => resetTurn(), 1000);
        }
    }, [choiceOne, choiceTwo]);

    useEffect(() => {
        shuffleCards();
    }, []);

    useEffect(() => {
        const foundUnmatched = cards.find((c) => !c.matched);
        if (!foundUnmatched && cards.length > 0) {
            setSolved(true);
        }
    }, [cards]);

    return (
        <React.Fragment>
            <div className="memory-game">
                <button onClick={shuffleCards}>Nová hra</button>

                {!solved && (
                    <div className="memory-game-card-grid">
                        {cards.map((card) => (
                            <SingleCard
                                card={card}
                                key={card.id}
                                handleChoice={handleChoice}
                                flipped={card === choiceOne || card === choiceTwo || card.matched}
                                disabled={disabled}
                            />
                        ))}
                    </div>
                )}
            </div>
            {solved && (
                <>
                    <div className="zdar-kids-cipher__bridge__solved">Úloha vyřešena</div>
                    {continueButtonText && <ContinueButton text={continueButtonText} onClick={onSuccess} />}
                </>
            )}
        </React.Fragment>
    );
}
